import { RadioGroup, Label } from '@heroui/react';
import { useController } from 'react-hook-form';
import { ReactNode } from 'react';

type FieldRadioButtonProps = {
  path: string;
  label?: ReactNode;
  children: ReactNode;
  [key: string]: unknown;
};

const FieldRadioButton = ({
  path,
  label,
  children,
  ...props
}: FieldRadioButtonProps) => {
  const { field } = useController({ name: path });

  return (
    <RadioGroup {...field} {...props}>
      {label && <Label>{label}</Label>}
      {children}
    </RadioGroup>
  );
};

export default FieldRadioButton;
